import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { setAmplifyLanguage } from "./I18nAmplifyUIForAuth";
// don't want to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    load: 'languageOnly',
    // Ensure all availalbe languages are preloaded (also non active langues are needed, e.g. for i18n of languages set)
    preload: ['en', 'cs', 'es', 'fr', 'zh-CN', 'ar', 'de', 'pt', 'hi', 'bn', 'ja', 'ko', 'pl'],
    fallbackLng: 'en',
    debug: true,
    // Configure backend to handle language codes properly
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    // Handle language code normalization
    nonExplicitSupportedLngs: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });

// Wire events
i18n
  .on('languageChanged', (lng) => {
    // When i18next language is changed, also change the language in AWS Amplify UI i18n module
    // This affects login and signup modules, this event is also called during initiation
    console.log('VHA languageChanged', lng);
    setAmplifyLanguage(lng);
  });


export default i18n;